module.exports = __webpack_public_path__ + "static/media/Montana2923.c23fb964.jpg";